// Centralized configuration for frontend runtime.
// REACT_APP_GRAPHQL_URL wins when set. Otherwise localhost talks to the local
// API, and every other host talks to production.
const productionGraphqlUrl = "https://aidabikic.com/graphql";
const localGraphqlUrl = "http://localhost:4001/graphql";

function defaultGraphqlUrl(): string {
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return localGraphqlUrl;
    }
  }
  return productionGraphqlUrl;
}

export const GRAPHQL_URL: string =
  (process.env.REACT_APP_GRAPHQL_URL as string) || defaultGraphqlUrl();
